import React from 'react';

import useWindowSize from '../hooks/useWindowSize';
import { SIZES } from '../constants/mediaQueries';
import MobileNav from './MobileNav';
import DesktopNav from './DesktopNav';

const Nav: React.FC = () => {
  const width = useWindowSize();
  const isDesktop = width > SIZES.laptop;

  return isDesktop ? <DesktopNav /> : <MobileNav />;
};

export default Nav;
